import logo from "./logo.svg";
import "./App.css";
import PrayerWall from "./PrayerWall";

function App() {
  return (
    <div className="App">
      <PrayerWall />
    </div>
  );
}

export default App;
